import { api } from "@/lib/api";

const MAX_SIDE = 2400;

async function compressImage(file) {
  if (!/^image\/(jpeg|png|webp|heic|heif)$/i.test(file.type) && !/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) return file;
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close?.();
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.88));
    if (!blob) return file;
    return new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" });
  } catch {
    return file;
  }
}

export async function uploadImage(file, headers) {
  const prepared = await compressImage(file);
  const fd = new FormData();
  fd.append("file", prepared);
  const { data } = await api.post("/admin/upload", fd, { headers, timeout: 120000 });
  return `/api/files/${data.path}`;
}

export function uploadErrorMessage(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (err?.response?.status === 413) return "Fichier trop volumineux (25 Mo max)";
  if (err?.code === "ECONNABORTED") return "Connexion trop lente — réessayez avec une photo plus légère";
  return fallback;
}
